export default __webpack_public_path__ + "static/media/Queen_Elizabeth_II_0012.3a31a02a.jpg";